import { Component } from '@angular/core';

@Component({
  selector: 'app-error418',
  templateUrl: './error418.component.html',
  styleUrls: ['../errors.css']
})
export class Error418Component {

}
